/**
 * Profile readiness for entering a (billable) video consultation.
 *
 * - France (Desmos billing) requires `isConsultationReady` = birthday + gender + secu (NIR).
 * - Other markets only require `isProfileComplete` = birthday + gender.
 *
 * Used by the waiting-room/live gates, the dashboard nudge banner, and the
 * complete-profile redirect. Keep in sync with the backend virtuals
 * (`patient.schema.ts` `isProfileComplete` / `isConsultationReady`).
 */
export type ReadinessInfo = { isProfileComplete?: boolean | null; isConsultationReady?: boolean | null } | null | undefined

export function isPatientReady(myInfos: ReadinessInfo, isFranceMode: boolean): boolean {
  if (!myInfos) return false
  return isFranceMode ? !!myInfos.isConsultationReady : !!myInfos.isProfileComplete
}
